import * as chatPremium from '@wix/chat-premium';

const ascendAppDefId = 'ee21fe60-48c5-45e9-95f4-6ca8f9b1c9d9';

const getAscendVendorProductId = (): Promise<string> =>
  new Promise((resolve) =>
    window.Wix.SuperApps.getAppVendorProductId(ascendAppDefId, resolve),
  );

const isPremium = async () => {
  const chatVendorProductId = window.Wix.Utils.getInstanceValue(
    'vendorProductId',
  );
  const ascendVendorProductId = await getAscendVendorProductId();

  return chatPremium.isPremium(chatVendorProductId, ascendVendorProductId);
};

export { isPremium };
